import React from "react";
import { FaEye } from "react-icons/fa";
import { stripHtmlToText } from "../../../utils/sanitizeHtml";

const SyllabusListItem = ({ syllabus, active, onSelect, onViewFile }) => {
  const classes = syllabus.syllabus_programs || [];

  return (
    <div
      className={`syllabus-list-item${active ? " active" : ""}`}
      onClick={() => onSelect(syllabus)}
    >
      <div className="syllabus-list-item-title">{syllabus.subject?.name}</div>

      {classes.length > 0 && (
        <div className="syllabus-list-item-classes">
          {classes.map((item) => item.program?.name).filter(Boolean).join(", ")}
        </div>
      )}

      <div className="syllabus-list-item-preview">
        {stripHtmlToText(syllabus.syllabus_desc)}
      </div>

      {syllabus.syllabus_docs && (
        <div className="syllabus-list-item-footer">
          <button
            type="button"
            className="syllabus-action-btn"
            onClick={(e) => {
              e.stopPropagation();
              onViewFile(syllabus.syllabus_docs);
            }}
          >
            <FaEye /> View File
          </button>
        </div>
      )}
    </div>
  );
};

export default SyllabusListItem;
